import { useHelpers } from '../../../../providers/HelpersProvider';
import { collect } from 'collect.js';
import React from 'react';

export default function OrderLineItemCard({ data }) {
  const { formatProductName } = useHelpers();

  return (
    <div className="bg-gray-50 p-sm space-y-sm rounded-lg">
      <h6 className="text-sm">
        {data.quantity}x {formatProductName(data)}
      </h6>
      {data.modifiers.length > 0 && <p>{collect(data.modifiers).implode('name', ' • ')}</p>}
      {Boolean(data.note) && <p className="italic">{data.note}</p>}
    </div>
  );
}
